import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
    FormGroup,
    FormControlLabel,
    Checkbox, Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const CustomTextField = styled(TextField)(({ theme }) => ({
    '& .MuiFilledInput-root': {
        backgroundColor: 'transparent',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
    },
    '& .Mui-focused': {
        borderColor: '#673ab7',
    },
    '& .MuiFilledInput-root.Mui-focused': {
        border: '1px solid #673ab7',
    },
}));

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'RelationName', label: 'Relation', minWidth: 100 },
    { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const RelationMaster = () => {
    const [formData, setFormData] = useState({
        RelationName: '',
        Remark: ''
    });

    const [error, setError] = useState({
        relationName: false
    });

    const navigate = useNavigate();

    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const location = useLocation();
    const [currentRelationId, setCurrentRelationId] = useState(null);
    const [mode, setMode] = useState('view');
    const [lastInsertedRelationId, setLastInsertedRelationId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [Status, setStatus] = useState("1");
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [relations, setRelations] = useState([]);
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });

    const relationNameRef = useRef(null);
    const RemarkRef = useRef(null);

    useEffect(() => {
        if (location.state && location.state.RelationId) {
            setCurrentRelationId(location.state.RelationId);
            fetchRelationData(location.state.RelationId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const fetchRelationData = async (id, flag) => {
        try {
            const response = await axios.post(`MstRelation/RetriveMstRelation`, {
                RelationId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const relationData = response.data.Data[0];
                setFormData({
                    RelationName: relationData.RelationName,
                    Remark: relationData.Remark
                });
                setStatus(relationData.Status.toString() || "0");
                setIsFormDisabled(true);
                setCurrentRelationId(relationData.RelationId);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.error('Failed to fetch relation master data');
            }
        } catch (error) {
            console.error('Error fetching relation master data:', error);
            toast.error('Error fetching relation master data. Please try again.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            const params = {
                start: 0,
                PageSize: 0,
                SearchText: ""
            };

            try {
                const res = await axios.post('MstRelation/getAllMstRelationDashBoard', { params });

                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                } else {
                    console.error('No data found in response');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    useEffect(() => {
        const fetchRelations = async () => {
            try {
                const response = await axios.post(`MstRelation/getMstRelationdrp`);
                if (
                    response.data.Status === 0 &&
                    response.data.responseStatusCode === 1
                ) {
                    setRelations(response.data.Data);
                } else {
                    toast.error("Failed to fetch Relations");
                }
            } catch (error) {
                console.error("Error fetching Relations:", error);
                toast.error("Error fetching Relations. Please try again.");
            }
        };

        fetchRelations();
    }, []);

    const handlePrevious = async () => {
        if (currentRelationId && currentRelationId > 1) {
            await fetchRelationData(currentRelationId, "P");
        }
    };

    const handleNext = async () => {
        if (currentRelationId) {
            await fetchRelationData(currentRelationId, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (name === 'relation') {
            setFormData(prevState => ({
                ...prevState,
                state: ''
            }));
        }

        if (name === 'relation' && value !== '') {
            setTimeout(() => {
                RemarkRef.current.focus();
            }, 100000);
        }
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === relationNameRef.current) {
                RemarkRef.current.focus();
            } else {
                RemarkRef.current.focus();
            }
        }
    };

    const handleSave = async () => {

        let hasError = false;

        if (!formData.RelationName) {
            toast.error('Relation Name is required');
            setError(prev => ({ ...prev, RelationName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, RelationName: false }));
        }

        if (hasError) {
            return;
        }

        try {
            const payload = {
                RelationName: formData.RelationName,
                Remark: formData.Remark,
                Status: Status
            };

            let response;
            if (mode === 'edit') {
                payload.RelationId = currentRelationId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axios.patch(`MstRelation/UpdateMstRelation`, payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axios.post(`MstRelation/InsertMstRelation`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedRelationId(response.data.Data)
                    await fetchRelationData(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentRelationId(response.data.Data);
                } else {
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            console.error('Error saving/updating Relation Master:', error);
            toast.error('Error saving/updating Relation Master. Please try again.');
        }
    };

    const handleEdit = async () => {

        let Flag = await checkAndLock(currentRelationId, "MstRelation", "RelationId");
        switch (Flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            RelationName: '',
            Remark: ''
        });
        setCurrentRelationId(null);

        setTimeout(() => {
            relationNameRef.current.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchRelationData(1, "L");
            await UnLock(currentRelationId, "MstRelation", "RelationId");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const resetForm = () => {
        setFormData({
            RelationName: '',
            Remark: ''
        });
        setCurrentRelationId(null);
        setMode('view');
    };

    const handleExit = () => {
        navigate('/relation-table')
    }

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {

        let Flag = await checkAndLock(currentRelationId, "MstRelation", "RelationId");
        switch (Flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchRelationData(currentRelationId, "D");
                await fetchRelationData(currentRelationId, "N");
                setMode('view');
                setIsFormDisabled(true);
                break;
            case 1: toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default: toast.info("Something Went Wrong", { autoClose: 500 });

        }

    };

    return (
        <>
            <ToastContainer />
            <Box className="form-container">
                <Grid container spacing={2} className="form_grid">
                    <Grid
                        item
                        xs={12}
                        className="form_title"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: "20px",
                            flexDirection: { xs: "column", sm: "row", md: "row" },
                        }}
                    >
                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: { xs: "center", sm: "flex-start" },
                                marginBottom: { xs: "10px", sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                sx={{
                                    backgroundColor: "#635bff",
                                    marginRight: { xs: "5px", sm: "10px" },
                                    display: { xs: "none", sm: "block" },
                                }}
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                disabled={mode !== 'view' || !currentRelationId || currentRelationId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                sx={{
                                    backgroundColor: "#635bff",
                                    display: { xs: "none", sm: "block" },
                                }}
                                className="three-d-button-next"
                                onClick={handleNext}
                                disabled={mode !== 'view' || !currentRelationId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: "Auto",
                                textAlign: { xs: "center", sm: "center" },
                                fontSize: { xs: "24px", sm: "18px", md: "24px" },
                            }}
                        >
                            Relation Master
                        </Typography>
                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="Relation Master"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleConfirmDelete}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        className="form_field"
                        sx={{ marginInline: { xs: "10px", sm: "80px" } }}
                    >
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <TextField
                                            id="RelationName"
                                            name="RelationName"
                                            label={
                                                <span>
                                                    RelationName <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={formData.RelationName}
                                            onChange={handleInputChange}
                                            disabled={isFormDisabled}
                                            inputRef={relationNameRef}
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3} lg={4}>
                                        <TextField
                                            fullWidth
                                            label="Remark"
                                            name="Remark"
                                            value={formData.Remark}
                                            onChange={handleInputChange}
                                            variant="filled"
                                            disabled={isFormDisabled}
                                            className="custom-textfield"
                                            inputRef={RemarkRef}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <FormGroup>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        disabled={isFormDisabled}
                                                        checked={Status === "1"}
                                                        onChange={handleChangeStatus}
                                                    />
                                                }
                                                label="Status"
                                            />
                                        </FormGroup>
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>

                    <div style={{ display: 'none' }}>
                        {Object.keys(DataForPrint).length > 0 && <ReportTable
                            columns={columns}
                            rows={rows}
                            title="Relation Master"
                            contentRef={contentRef}
                            customStyles={{ backgroundColor: '#f5f5f5' }}
                        />
                        }
                    </div>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #d4d4d4)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #b9d0e9, #e9f2fa)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>

                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave} >
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>

                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            {/* Delete Confirmation Modal */}
            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: "#635bff",
                            color: "white",
                            "&:hover": {
                                backgroundColor: "#1565c0",
                                color: "white",
                            },
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: "#635bff",
                            color: "white",
                            "&:hover": {
                                backgroundColor: "#1565c0",
                                color: "white",
                            },
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default RelationMaster
